import { useSearchParams, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const { user, loginWithTwitch } = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const error = searchParams.get('error');

  // Redirect to dashboard if already logged in
  useEffect(() => {
    if (user) {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  return (
    <div className="min-h-screen bg-dark-900 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-center gap-2 text-white hover:text-primary transition-colors">
            <div className="w-10 h-10 rounded-lg overflow-hidden bg-primary flex items-center justify-center">
              <img src="/logo-300x300.png" alt="Clipto logo" className="w-full h-full object-cover" />
            </div>
            <span className="font-bold text-xl">Clipto</span>
          </Link>
        </div>

        <div className="bg-dark-800 border border-dark-600 rounded-xl p-6">
          <h1 className="text-2xl font-bold text-center mb-6">Welcome Back</h1>

          {error && (
            <div className="mb-6 p-4 bg-red-900/20 border border-red-500/30 rounded-lg text-red-400 text-sm">
              <p className="font-medium">Login failed</p>
              <p className="mt-1">{error}</p>
            </div>
          )}

          <button
            onClick={loginWithTwitch}
            className="w-full flex items-center justify-center gap-3 px-6 py-3 bg-primary hover:bg-primary-hover text-white font-semibold rounded-lg transition-all"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714z"/>
            </svg>
            Continue with Twitch
          </button>

          <p className="mt-4 text-center text-sm text-gray-500">
            We only request access to your email and basic profile.
          </p>
        </div>

        <p className="mt-6 text-center text-sm text-gray-500">
          <Link to="/" className="text-primary hover:underline">
            ← Back to home
          </Link>
        </p>
      </div>
    </div>
  );
}
